<template>
  <div id="snowfall-dashboard">
    <div class="background-container">
      <div id="top-section">
        <div id="dashboard-blocks">
          <div id="main-col">
            <snowfallChart class="dashboard-block" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import SnowfallChart from '@/components/SnowfallChart.vue';

export default {
  name: 'SnowfallDashboard',
  components: {
    SnowfallChart,
  },
  computed: {
    ...mapState(['showSnowfallChart']),
  },
};
</script>

<style lang="scss" scoped>
@import '~@/scss/site';

#snowfall-dashboard {
  #dashboard-blocks {
    width: 100%;
    #main-col {
      position: relative;
      width: 100%;
    }
  }
  .dashboard-block {
    background-color: $white;
    margin: 50px 0 30px;
    padding: 20px;
    width: 100%;
    @media (min-width: $tablet) {
      box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.1);
      padding: 30px 35px;
    }
    &.snowfall-chart {
      margin-top: 50px;
    }
  }
}
</style>
